/* tslint:disable */
/* eslint-disable */
/**
 * gtep-rfp-api API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicantRequestDto
 */
export interface ApplicantRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicantRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicantRequestDto
     */
    mailingAddress: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicantRequestDto
     */
    emailAddress: string;
}

export function ApplicantRequestDtoFromJSON(json: any): ApplicantRequestDto {
    return ApplicantRequestDtoFromJSONTyped(json, false);
}

export function ApplicantRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicantRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'mailingAddress': json['mailingAddress'],
        'emailAddress': json['emailAddress'],
    };
}

export function ApplicantRequestDtoToJSON(value?: ApplicantRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'mailingAddress': value.mailingAddress,
        'emailAddress': value.emailAddress,
    };
}

